import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 3C3.75 2.58579 3.41421 2.25 3 2.25C2.58579 2.25 2.25 2.58579 2.25 3V4.49932V4.49932V21C2.25 21.4142 2.58579 21.75 3 21.75C3.41421 21.75 3.75 21.4142 3.75 21V15.5854L5.9522 15.0345C7.86285 14.557 9.88136 14.7788 11.6428 15.6597L11.7509 15.7138C13.791 16.7334 16.124 17.0056 18.344 16.483L21.4578 15.751C21.8267 15.6643 22.0729 15.3161 22.0317 14.9394C21.6562 11.5042 21.6546 8.03831 22.0268 4.6027C22.053 4.36074 21.9602 4.1211 21.7778 3.95993C21.5955 3.79876 21.3462 3.7361 21.1093 3.79186L17.9993 4.52386C16.1211 4.96555 14.1474 4.73491 12.4216 3.87208L12.3136 3.81809C10.2319 2.77699 7.8464 2.51494 5.58832 3.0793L3.75 3.53921V3ZM3.75 5.08544V14.0392L5.58815 13.5793C7.84626 13.015 10.2319 13.277 12.3137 14.3181L12.4215 14.372C14.1477 15.2348 16.1219 15.4651 18.0003 15.0229L20.4729 14.4416C20.1881 11.4656 20.1749 8.47 20.4331 5.49203L18.343 5.98397C16.1232 6.50601 13.7905 6.23349 11.7508 5.21375L11.6428 5.15974C9.88136 4.2788 7.86285 4.05701 5.9522 4.53449L3.75 5.08544Z"
        fill={colorValue}
      />
    </svg>
  );
};
